import settings from '@/lib/settings.js'
import eventbus from '@/eventbus.js'
import { store } from '@/shared-store.js'

export default {
	data() {
		return {
			requestedRaceId: undefined
		}
	},
	
  mounted() {
    this.selectRaceAvoidEmptySelection();
		eventbus.on('requestRaceId', this.filterToRace);
  },
	
	unmounted() {
		eventbus.removeListener('requestRaceId', this.filterToRace);
	},
  
  computed: {
    races() { 
      return this.raceEvent?.races || [];
      // const ids = this.raceEvent?.races || [];
      // return ids ? this.$store.getters.entity('races', ids).sort((a,b) => a.distance - b.distance) : [];
    },
    
    filteredRaceIds: {
      get() {
        return store.state.filteredRaceIds || {};
      },
      set(ids) {
        store.setFilteredRaceIds(ids || {});

        const val = Object.keys(store.state.filteredRaceIds)
          .filter(id => store.state.filteredRaceIds[id]);
        settings.lastSelectedRaceIds = val.map(id => Number(id));
      }
    },
    
    filteredRaces: {
      get() {
        const ids = this.filteredRaceIds;
        const fids = Object.keys(ids).filter(id=> ids[id] ).map(id=>parseInt(id));
      
        return this.races.filter(r => fids.includes(r.id))
      },
      set(v) {
        let ids = {};
        if (Array.isArray(v)) {
          ids = v.reduce((acc, r) => {
            const id = r?.id ?? r;
            if (id != null) acc[id] = true;
            return acc;
          }, {});
        }
        else if (typeof v === 'number') {
          ids[v] = true;
        }
                
        this.filteredRaceIds = ids;
      }
    },
    
    racesByTime() {
      if (!this.raceEvent) return [];
      return [...(this.raceEvent.races || [])]
        .sort((a,b) => (a.startTime || Number.POSITIVE_INFINITY) - (b.startTime || Number.POSITIVE_INFINITY));
    },
    
    selectedRaces() {
      return this.races.filter(r=>this.filteredRaceIds[r.id]).sort((a,b) => a.startTime - b.startTime);
    },
		
		activeRaceIds() {
      return this.activeRaces.map(r=>r.id);
      
      // const frids = this.filteredRaceIds;
      // const rids = Object.keys(frids).filter(rid => frids[rid]) // {123: true, 125: false}
      // return rids.length > 0 ? rids
      //                        : this.races.map(r => r.id);
		},
    
    // What the UI references; if selectedRaces isn't populated we'll return all
    // current races.
    activeRaces() {
      if (this.selectedRaces.length < 1)
        return this.races;
      else
        return this.selectedRaces;
    },
  },
  
  methods: {
		loadDidFinish(entityName) {
			if ("race" == entityName && undefined != this.requestedRaceId) {
				console.log("race-filters loadDidFinish hook");
				this.filterToRace(this.requestedRaceId);
				eventbus.removeListener('loadDidFinish', this.loadDidFinish);
			}
		},
		
    filterToRace(race, event, initial=false) {
			console.log(`filterToRace: race:${race} event:${event} (dispatching)`)
			
			// Support raceIds
			if (Number.isInteger(race)) {
				let raceId = race;
				race = this.races.find(r => r.id === raceId) || store.state.race?.[raceId];

				if (!race) {
					this.requestedRaceId = raceId;
					eventbus.on('loadDidFinish', this.loadDidFinish);
					return;
				}
			}

      const extendingSelection = !!(event && event.shiftKey);
      const filteredRaceIds = { ...this.filteredRaceIds };

      if (extendingSelection) {
        if (race) {
          filteredRaceIds[race.id] = !filteredRaceIds[race.id];
        }
        else {
          this.races.forEach(r => {
            filteredRaceIds[r.id] = !filteredRaceIds[r.id];
          });
        }

        this.filteredRaceIds = filteredRaceIds;
        return;
      }

      Object.keys(filteredRaceIds).forEach(k => {
        filteredRaceIds[k] = false;
      });

      if (race) {
        filteredRaceIds[race.id] = true;
      }

      this.filteredRaceIds = filteredRaceIds;
    },
        
    selectRaceAvoidEmptySelection() {
      let ids = settings.lastSelectedRaceIds,
          committedIds = {},
          count=0;
      
      const raceIds = this.races.map(r=>r.id);
      
      // Make sure the last selected raceIds are in the active raceEvent.
      if (ids.length) {
        ids.forEach(id => {
          if (raceIds.includes(id)) {
            committedIds[id] = true; 
            count++
          }
        });
      }

      // Either commit the determined raceIds so everyone else
      // can use them, or pick a race to select.
      //
      if (count > 0) {
        this.filteredRaceIds = committedIds;
      }
      else {
        // We couldn't be sticky, so select the first race.
        if (this.races && this.races.length > 0) {
          this.filterToRace(this.races[0], null, /*initial=*/true);
        }
      }
      
    },
  },
  
}
